export default __webpack_public_path__ + "static/media/WordPress_logo.caf6e3f3.svg";